import { Button } from "@/components/ui/button";

export const Hero = () => {
  return (
    <div className="relative min-h-[80vh] flex items-center justify-center overflow-hidden pt-16">
      {/* Background gradient */}
      <div className="absolute inset-0 bg-skuhub-navy">
        <div className="absolute inset-0 bg-gradient-to-r from-skuhub-coral/20 to-skuhub-orange/20 opacity-50" />
      </div>

      {/* Content */}
      <div className="container relative z-10 px-4 py-32 mx-auto text-center">
        <h1 className="mb-6 text-5xl font-bold tracking-tight text-white md:text-6xl lg:text-7xl">
          Seamless Shopify Integration
          <span className="block mt-2 bg-gradient-to-r from-skuhub-coral to-skuhub-orange bg-clip-text text-transparent">
            For Your Store
          </span>
        </h1>
        <p className="max-w-2xl mx-auto mb-8 text-lg text-gray-300 md:text-xl">
          Integrate Shopify products into your e-commerce platform with our powerful API
          and built-in Shopify web app. Start selling your products effortlessly.
        </p>
        <div className="flex flex-col items-center justify-center gap-4 md:flex-row">
          <Button
            size="lg"
            className="bg-gradient-to-r from-skuhub-coral to-skuhub-orange hover:opacity-90 transition-opacity"
          >
            Get Started
          </Button>
        </div>
      </div>
    </div>
  );
};